export const badgeVariants = {
  variant: {
    default: 'border-transparent bg-neutral-900 text-neutral-50 hover:bg-neutral-900/80',
    outline: 'text-neutral-950',
    gray: 'bg-neutral-100 text-neutral-600',
    active: 'bg-success-100 text-success-700 border-success-100',
    pending: 'bg-info-100 text-info-700 border-info-100',
    deactivated: 'bg-danger-100 text-danger-500 border-danger-100',
    temporaryDisabled: 'bg-warning-100 text-warning-700 border-warning-100',
  },
};
